Vue.asyncComponent('cms-share-menu-item', {
    data() {
        return {
            openModal: false,
        }
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        active: {
            type: Boolean,
            required: false,
        },
        showArrow: {
            type: Boolean,
            required: false,
            default: true,
        },
        colorMode: {
            type: String,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        objectId: {
            type: String,
            required: true
        },
        typeId: {
            type: Number|String,
            required: true
        },
        gridBundleId: {
            type: String,
        },
        gridDefinitionId: {
            type: String,
        }
    }
}, 'cms/share/cms-share-menu-item.html');